import { render, staticRenderFns } from "./TrashedMembersItem.vue?vue&type=template&id=bbb2af7c"
import script from "./TrashedMembersItem.vue?vue&type=script&lang=js"
export * from "./TrashedMembersItem.vue?vue&type=script&lang=js"
import style0 from "./TrashedMembersItem.vue?vue&type=style&index=0&id=bbb2af7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports